"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubConnaissancesMarcheFinancierProduitsEpargneCorporation = void 0;
exports.ESubConnaissancesMarcheFinancierProduitsEpargneCorporation = {
    aucune: "aucune",
    faible: "faible",
    moyenne: "moyenne",
    eleve: "eleve",
    expert: "expert",
};
